import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { CountryService } from '../services/country.service';
import { Country } from '../models/country.model';
import { InfraService } from '../services/infra.service';

@Injectable()
export class CountryResolver  {
  countrylist: Country[];
  constructor(private countryService: CountryService, private infraService: InfraService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const countryId = route.paramMap.get('countryId');
    if(countryId) {
      this.countryService.getcountrylist().subscribe((data: Country[]) => {
        this.countrylist = data;
        const country = this.countrylist.find(el => el.Id === Number(countryId));
        const dRegionId = country.InfraId.toString();
        localStorage.setItem('selectedInfra', +countryId+',0,' + dRegionId);
        this.infraService.setInfraDetails(`${countryId},0,${dRegionId}`);
        return true;
      });
    } else {
      return true;
    }
  }

}
